module.exports = __webpack_public_path__ + "img/tj.6f83dc6a.svg";